import nestContent from "../Assets/Data/NestContent";

const getNest = (game, nest) => {
    return nestContent[game][nest]["Entries"];
}

const minRank = mon => {
    for(var i = 0; i < 5; i++) {
        if(mon.Probabilities[i] > 0) {
            return i;
        }
    }
    return -1;
}

const maxRank = mon => {
    for(var i = 4; i >= 0; i--) {
        if(mon.Probabilities[i] > 0) {
            return i;
        }
    }
    return -1;
}

function compare(a, b) {
    return minRank(a) > minRank(b) ? 1 : minRank(a) < minRank(b) ? -1 : 0;
  }

function entryString(cur) {
    return cur.Species + "." + minRank(cur) + "." + maxRank(cur) + "." + cur.FlawlessIVs + "." + cur.Ability + "." + cur.AltForm + "." + cur.IsGigantamax + "." + cur.Nature + "." + cur.ShinyForced;
}

const shrinkNest = nest => {
    const usedUp = new Set();
    return nest.reduce(((prev, cur) => {
        if (maxRank(cur) === -1) {
            return prev;
        }
        const tmp = entryString(cur);
        if(usedUp.has(tmp)) {
            return prev;
        } else {
            usedUp.add(tmp);
            return prev.concat(cur);
        }
    }), []).sort(compare);
}

function intersection(setA, setB) {
    var _intersection = new Set();
    for (var elem of setB) {
        if (setA.has(elem)) {
            _intersection.add(elem);
        }
    }
    return _intersection;
}

function difference(setA, setB) {
    var _difference = new Set(setA);
    for (var elem of setB) {
        _difference.delete(elem);
    }
    return _difference;
}



const getCommonNest = nest => {
    const n1 = shrinkNest(getNest(0, nest));
    const n2 = shrinkNest(getNest(1, nest));
    const map1 = {};
    const map2 = {};
    n1.map(entry => {
        map1[entryString(entry)] = entry;
        return 0;
    });
    n2.map(entry => {
        map2[entryString(entry)] = entry;
        return 0;
    });
    const res = [];
    const s1 = new Set(n1.map(entry => entryString(entry)));
    const s2 = new Set(n2.map(entry => entryString(entry)));
    const common = Array.from(intersection(s1, s2));
    const s1only = Array.from(difference(s1, s2));
    const s2only = Array.from(difference(s2, s1));
    common.forEach(e => {
        const element = map1[e];
        element["game"] = 2;
        res.push(element);
    });
    s1only.forEach(e => {
        const element = map1[e];
        element["game"] = 0;
        res.push(element);
    });
    s2only.forEach(e => {
        const element = map2[e];
        element["game"] = 1;
        res.push(element);
    });
    return res.sort(compare);
}

export default shrinkNest;
export { getNest, shrinkNest, minRank, maxRank, getCommonNest };